
// export const baseUrl = "https://backendapi.homesforsalemedia.com"
export const baseUrl = process.env.REACT_APP_STAGING_BACKEND_API || "https://backendapi.bcrumbs.com"
export const login = "/api/token/";
export const verifyToken = "/api/token/verify/";
export const refreshToken = "/api/token/refresh/";
export const logout = "/api/logout/";
export const logoutAllDevices = "/api/auth/logout-all/";
export const keepAlive = "/api/auth/keep-alive/";
export const syncLocations = "/api/onboard_locations/";
export const syncLocations_v2 = "/api/sync_onboarded_locations/";
export const locationList = "/api/locationList/";
export const globalUsers = "/api/global_users/";
export const userList = "/api/users/";
export const getUser = "/api/user/";
export const campaignList = "/api/campaignList/";
export const fallbackUserList = "/api/campaignFallBackUsers/";
export const fallbackUserCreate = "/api/campaignFallBackUsersCreate/";
export const fallbackUserDelete = "/api/campaignFallBackUsersDelete/";
export const lockCampaignUrl = "/api/lockCampaign/";
export const lockUserUrl = "/api/lockUser/";
export const lockLocationUrl = "/api/lockLocation/";
export const campaignUserList = "/api/campaignUsers/";
export const userUpdate = "/api/userUpdate/";
export const campaignUserUpdate = "/api/campaignUserUpdate/";
export const purchaseList = "/api/purchaseList/";
export const purchaseFormData = "/api/purchaseFormData/";
export const purchaseInitiate = "/api/purchaseInitiate/";
export const purchaseGet = "/api/purchaseGet/";
export const purchaseEdit = "/api/purchaseEdit/";
export const purchasedelete = "/api/purchaseDelete/";
export const purchaseCreate = "/api/createPurchaseOrder/";
export const getLanguageCampaign = "/api/get_language_campaign/";
export const getLanguages = "/api/get_languages/";
export const addNewLanguages = "/api/addNewLanguages/"
export const deleteLanguage = "/api/deleteLanguage/";
export const addNewCampaign = "/api/addNewCampaign/";
export const locationManage = "/api/locationManage/";
export const locationAdd = "/api/validation/";
export const dashboardFilterData = "/api/dashboard_filters/";
export const dashboardReports = "/api/dashboard_reports/";
export const dashboardLeads = "/api/dashboard_leads/";
export const leaderCreate = "/api/leader_create/"
export const teamCreate = "/api/team_create/"
export const teamUpdate = "/api/team_update/"
export const userCreate = "/api/user_create/"
export const getTeams = "/api/get_teams/"
export const getLeaders = "/api/get_leaders/"
export const getGhlUsers = "/api/get_ghl_users/"
export const deleteLeader = "/api/delete_leader/"
export const deleteTeam = "/api/delete_team/"
export const leaderLocations = "/api/get_leader_locations/"
export const leaderTeams = "/api/get_leader_teams/"
export const teamLocations = "/api/get_team_locations/"
export const leaderLocationManage = "/api/leaderLocationManage/"
export const leaderTeamManage = "/api/leaderTeamManage/"
export const teamLocationManage = "/api/teamLocationManage/"
export const AppUserList = "/api/CustomAppUserList/"
export const getAppLead = "/api/getCustomAppLead_v2/"
export const get_form_initials = "/api/get_form_initials/"
export const form_submit = "/api/custom_form_submission/"
export const new_form_submit = "/api/custom_form_submission_v2/"

export const UpdateAppStage = "/api/UpdateAppStage/"
export const AddFollowers = "/api/add_followers/"
export const BulkAddFollowers = "/api/bulk_add_followers/"
export const BulkAddAssignedUsers = "/api/bulk_add_assigned_users/"
export const AddSales = "/api/add_sales/"
export const MoveToFollower = "/api/move_to_followers/"
export const MoveToSales = "/api/move_to_sales/"
export const RemoveFollowerSales = "/api/remove_follower_sales/"
export const updateAssignedUser = "/api/update_assigned_user/"
export const appSubmissionList = "/api/app_submission_list/"
export const appSubmissionListByStage = "/api/app_submission_list_by_stage/"
export const appKanbanUserList = "/api/app_user_list/"
export const createComment = "/api/create_comment/"
export const updateComment = "/api/update_comment/"
export const deleteComment = "/api/delete_comment/"
export const passwordUpdate = "/api/password_update/"
export const updateUserName = "/api/update_user_name/"
export const sendMessage = "/api/send-message/"
export const UpdateCustomAppLead = "/api/UpdateCustomAppLead/"
export const deleteProfileData = "/api/deleteProfileData/"
export const auditLog = "/api/auditLog/"
export const appSubmission = "/api/app_submission/"

export const createCheckListHeading =  "/api/create_checklist_heading/"
export const updateCheckListHeading = "/api/update_checklist_heading/"
export const deleteCheckListHeading = "/api/delete_checklist_heading/"
export const createCheckList = "/api/create_checklist/"
export const updateCheckList = "/api/update_checklist/"
export const deleteCheckList = "/api/delete_checklist/"
// export const getNotifications = "/api/get_notifications/"
export const getNotifications = "/api/get_notifications_v2/"
export const notificationOpened = "/api/notification_opened/"
export const notificationFlag = "/api/notification_flag/"
export const labelCreate = "/api/label_create/"
export const labelUpdate = "/api/label_update/"
export const labelDelete = "/api/label_delete/"
export const descriptionAdd = "/api/add_description/"

export const getLabel = "/api/get_label/"
export const addLabel = "/api/add_label/"
export const removeLabel = "/api/remove_label/"
export const registeredUserList = "/api/registered_app_user_list/"

export const getPipelines = "/api/get_pipelines/"
export const upsertPipeline = "/api/upsert_pipeline/"
export const deletePipeline = "/api/delete_pipeline/"
// export const getOpportunitiesList = "/api/get_opportunity_list/"
export const getOpportunitiesList = "/api/get_search_opportunity_list/"
export const getOpportunitiesListByStage = "/api/get_opportunity_list_by_stage/"
export const UpdateLeadStage = "/api/UpdateLeadStage/"

export const getUserPipelines = "/api/get_user_pipelines/"
export const getUserOpportunitiesList = "/api/get_user_opportunity_list/?pipelineId=1&sort=ASC"
export const getUserOpportunitiesListByStage = "/api/get_user_opportunity_list_by_stage/?stageId=1&sort=ASC&limit=5&offset=0"
export const updateUserStage = "/api/UpdateUserStage/"
export const getUserOpportunityCard = "/api/get_user_opportunity_card/"
export const createUserComment = "/api/create_user_comment/"
export const updateUserComment = "/api/update_user_comment/"
export const deleteUserComment = "/api/delete_user_comment/"

export const upserDesignation = "/api/upsert_designation/"
export const upsertSubDesignation = "/api/upsert_subdesignation/"
export const deleteSubDesignation = "/api/delete_subdesignation/"
export const getDesignations = "/api/get_designations/"
export const deleteDesignation = "/api/delete_designation/"
export const updateUserDesignation = "/api/update_user_designation/"

export const getCustomFields = "/api/get_custom_fields/"
export const createCustomField = "/api/create_custom_field/"
export const updateCustomField = "/api/update_custom_field/"
export const deleteCustomField = "/api/delete_custom_field/"
export const upserCustomFieldValue = "/api/upsert_custom_field_value/"

export const toggleWatcher = "/api/toggle_watcher/"

export const archiveSubmission = "/api/archive_submission/"
export const inactiveSubmission = "/api/inactive_submission/"
export const unarchiveSubmission = "/api/unarchive_submission/"
export const deleteSubmission = "/api/delete_submission/"
export const getArchivedSubmissionList = "/api/archived_submission_list/"
export const updateDueDate = "/api/update_due_date/"

export const getLeaderBoard = "/api/get_leadborad/"
export const getShoppersLeaderBoard = "/api/get_leadborad/"
export const updateShopperGoal = "/api/update_shopper_goal/"

export const upsertCompany = "/api/upsert_company/"
export const getCompanies = "/api/get_companies/"
export const deleteCompany = "/api/delete_company/"
export const updateUserCompany = "/api/update_user_company/"

export const getAvailabilityslots = "/api/get_availability_slots/"
export const upsertAvailabilitySlot = "/api/upsert_availability_slot/"
export const createBlockSlot = "/api/create_block_slot/"
export const getBlockedSlots = "/api/get_blocked_slots/"
export const deleteBlockedSlot = "/api/delete_blocked_slot/"
export const getAvailableUsers = "/api/get_available_users/"
export const getAllCustomUsers =  "/api/get_all_custom_users/"
export const toggleAvailabilitySlots = "/api/toggle_availability_slots/"

export const updateCheckListOrder = "/api/update_checklist_order/"

export const createCheckListTemplateHeading = "/api/create_checklist_template_heading/"
export const updateCheckListTemplateHeading = "/api/update_checklist_template_heading/"
export const deleteCheckListTemplateHeading = "/api/delete_checklist_template_heading/"
export const getCheckListTemplateHeadings = "/api/get_checklist_template_headings/"

export const createCheckListTemplateItem = "/api/create_checklist_template/"
export const updateCheckListTemplateItem = "/api/update_checklist_template/"
export const deleteCheckListTemplateItem = "/api/delete_checklist_template/"
export const updateCheckListTemplateItemsOrder = "/api/update_checklist_template_order/"
export const getCheckListTemplate = "/api/get_checklist_template/"

export const sendInternalChecklistNotification = "/api/send_internal_ckecklist_notification/"
export const sendChecklistToContact = "/api/send_ckecklist_to_contact/"

export const shortFormSubmission = "/api/custom_short_form_submission/"
export const newHomeOwnerAppSubmission = "/api/custom_home_owner_short_form_submission/ "
export const checkAppExists = "/api/check_app_exists/"

export const toggleStageWatcher = "/api/toggle_stage_watcher/"
export const getReportApps = "/api/get_report_apps/"

export const userOnboard = "/api/onboard_user/"
export const getSoftwareUsers = "/api/get_software_users/"
export const convertToUser = "/api/convert_to_user/"
export const convertToLeader = "/api/convert_to_leader/"
export const terminateSoftwareUser = "/api/terminate_software_user/"
export const changeUserStatus = "/api/change_user_status/"
export const updateOfficeEmailPassword = "/api/update_360/"

export const getStageWatchers = "/api/get_stage_watcher/"
export const addStageWatchers = "/api/add_stage_watcher/"
export const removeStageWatchers = "/api/remove_stage_watcher/"

export const getReportLeads = "/api/get_report_leads/"
export const updateLeadAssignedUser = "/api/update_lead_assigned_user/"
export const sendCredentialsEmail = "/api/send_credentials_email/"

export const syncWithPhoneApp = "/api/get_lead/"
export const downloadXmlFile = "/api/download_xml/"
export const autoDocFollowupToggle = "/api/toggle_doc_followup/"
export const toggleWorkingOn = "/api/toggle_working_on/"

export const getFlyerData = "/api/user_flyer/"
export const updateFlyer = "/api/user_flyer/"

export const getBranches = "/api/branches/"
export const createBranch = "/api/branches/"
export const deleteBranch = "/api/branches/"
export const addCostCenter = "/api/branches/"
export const updateCostCenter = "/api/costcenters/"
export const deleteCostCenter = "/api/costcenters/"

export const updateActivePipelineAccount = "/api/update_active_pipeline_account/"

export const getTrackingMsgs = "/api/get_app_message_data/"

export const getQueueItems = "/api/my_queue/"
export const reorderQueue = "/api/my_queue/reorder/"
export const removeQueueItem = "/api/my_queue/remove_item/";
// export const addToQueue = "/api/my_queue/add_item/"
export const addToQueue = "/api/my_queue/add_item_for_user/"
export const getUserActivityLogs = "/api/activity_logs/"
export const updateApplicationPipeline = "/api/update_app_pipeline_account/"
export const updateAppFollowers = "/api/update_app_followers/"
export const updateUserLanguages = "/api/update_user_languages/"

export const getChecklistSuggestions = "/api/checklist-name-suggestions/"
export const createChecklistSuggestion = "/api/checklist-name-suggestions/create/"
export const updateChecklistSuggestion = "/api/checklist-name-suggestions/update/"
export const deleteChecklistSuggestion = "/api/checklist-name-suggestions/delete/"
export const bulkDeleteChecklistSuggestions = "/api/checklist-name-suggestions/bulk-delete/"

export const loginOtpInitiate = "/api/auth/otp/initiate/";
export const loginOtpSend = "/api/auth/otp/send/";
export const loginOtpVerify = "/api/auth/otp/verify/";
export const passwordResetInitiate = "/api/auth/password-reset/initiate/";
export const passwordResetVerify = "/api/auth/password-reset/verify/";
export const passwordResetConfirm = "/api/auth/password-reset/confirm/";
export const downloadFilesZip = "/api/download-files-zip/"
export const createAppDoc = "/api/app-docs/"
export const updateAppDoc = "/api/app-docs/"
export const getAppDocsByApp = "/api/app-docs/app/"
export const encryptionKey = "/api/encryption-key/"

export const toggleUserLockout = "/api/admin/users/";
export const toggleKpiManaged = "/api/admin/users/";

// Pending Closing Queue
export const pendingClosingsQueue = "/api/admin/queue/pending-closings/"
export const projectedClosingsQueue = "/api/admin/queue/projected-closings/"
export const updateClosingDateQueue = "/api/admin/queue/update-closing-date/"
export const pingClientQueue = "/api/admin/queue/ping-client/"

// Repeat Leads
export const getRepeatLeads = '/api/repeat_leads/'

// Onboarding — Admin
export const onboardingInviteCreate = "/api/admin/onboarding/invites/"
export const onboardingInviteList = "/api/admin/onboarding/invites/list/"
export const onboardingInviteRevoke = (id) => `/api/admin/onboarding/invites/${id}/revoke/`
export const onboardingInviteDelete  = (id) => `/api/admin/onboarding/invites/${id}/`
export const onboardingSendAppLink   = '/api/onboarding/send-app-link/'

// Onboarding — User-facing (public, no auth)
export const onboardingValidate = (token) => `/api/onboarding/invite/${token}/`
export const onboardingOtpSend = "/api/onboarding/otp/send/"
export const onboardingOtpVerify = "/api/onboarding/otp/verify/"
export const onboardingComplete = "/api/onboarding/complete/"
export const onboardingSla = "/api/onboarding/sla/"

// Help Desk
export const helpDeskTickets = "/api/tickets/"
export const helpDeskTicketDetail = (id) => `/api/tickets/${id}/`
export const helpDeskTicketComments = (id) => `/api/tickets/${id}/comments/`
export const helpDeskTicketAttachments = (id) => `/api/tickets/${id}/attachments/`
export const helpDeskAttachmentDetail = (attachmentId) => `/api/tickets/attachments/${attachmentId}/`
export const helpDeskTicketActivity = (id) => `/api/tickets/${id}/activity/`
export const isFirstQualifiedApp = (customUserId, appId) => `/api/is_first_qualified_app/${customUserId}/${appId}`
